export default __webpack_public_path__ + "static/media/arche_banner.6332d822.jpeg";